const types = {
  setSessionFilters: 'SET_SESSION_FILTERS',
  getChartData: {
    request: 'GET_GSE_CHART_DATA_REQUEST',
    success: 'GET_GSE_CHART_DATA_SUCCESS',
    failure: 'GET_GSE_CHART_DATA_FAILURE'
  },
  getChartList: {
    request: 'GET_GSE_CHART_LIST_REQUEST',
    success: 'GET_GSE_CHART_LIST_SUCCESS',
    failure: 'GET_GSE_CHART_LIST_FAILURE',
    clear: 'CLEAR_GSE_CHART_LIST'
  },
  getFilters: {
    request: 'GET_GSE_FILTER_REQUEST',
    success: 'GET_GSE_FILTER_SUCCESS',
    failure: 'GET_GSE_FILTER_FAILURE'
  },
  getBottomUpFilter: {
    request: 'GET_BOTTOM_FILTER_REQUEST',
    success: 'GET_BOTTOM_FILTER_SUCCESS',
    failure: 'GET_BOTTOM_FILTER_FAILURE',
    stale: 'GET_BOTTOM_FILTER_STALE'
  },
  getFilter: {
    request: 'GET_FILTER_REQUEST',
    success: 'GET_FILTER_SUCCESS',
    failure: 'GET_FILTER_FAILURE',
    stale: 'GET_FILTER_STALE'
  },
  bumpFilterEpoch: 'BUMP_FILTER_EPOCH',
  // the three session-data legs, fetched in parallel. each carries the filter
  // epoch so a response computed under a superseded filter set is discarded
  // instead of being assembled together with a fresher leg.
  getSessionDataImages: {
    request: 'GET_GSE_SESSION_IMAGES_REQUEST',
    success: 'GET_GSE_SESSION_IMAGES_SUCCESS',
    failure: 'GET_GSE_SESSION_IMAGES_FAILURE',
    stale: 'GET_GSE_SESSION_IMAGES_STALE'
  },
  getSessionDataMisc: {
    request: 'GET_GSE_SESSION_MISC_REQUEST',
    success: 'GET_GSE_SESSION_MISC_SUCCESS',
    failure: 'GET_GSE_SESSION_MISC_FAILURE',
    stale: 'GET_GSE_SESSION_MISC_STALE'
  },
  getSessionDataVariants: {
    request: 'GET_GSE_SESSION_VARIANTS_REQUEST',
    success: 'GET_GSE_SESSION_VARIANTS_SUCCESS',
    failure: 'GET_GSE_SESSION_VARIANTS_FAILURE',
    stale: 'GET_GSE_SESSION_VARIANTS_STALE'
  },
  splitSessionDataClear: 'GSE_SPLIT_SESSION_DATA_CLEAR',
  downloadChartData: {
    request: 'DOWNLOAD_GSE_CHART_DATA_REQUEST',
    success: 'DOWNLOAD_GSE_CHART_DATA_SUCCESS',
    failure: 'DOWNLOAD_GSE_CHART_DATA_FAILURE'
  },
  genericSEfilterChange: 'GSE_FILTER_CHANGE_NOTIFICATION',
  sessionFilterValues: {
    request: 'GET_SESSION_FILTER_VALUES_REQUEST',
    success: 'GET_SESSION_FILTER_VALUES_SUCCESS',
    error: 'GET_SESSION_FILTER_VALUES_FAILURE'
  }
};

export default types;
